import { Uri } from '@nextforce/api'

const keys = {
  all: ['users'],
  detail: (companyId?: string) => [...keys.all, 'me', companyId],
  badge: () => [...keys.detail(), 'badge'],
  account: () => [...keys.detail(), 'profile'],
  list: (uri: Uri) => [...keys.all, 'list', `?${uri}`],
  profiles: () => [...keys.all, 'profiles'],
  profile: (uri: Uri) => [...keys.profiles(), `?${uri}`],
}

export default keys
